import { useGame } from '../state/store'
import { GLOBAL } from '../config/global'
import { TYPEFACE, UI } from '../config/colors'

const BRANCHES = [
  {
    key: 'serif',
    name: 'Serif',
    desc: '+15% global Ink production',
    color: TYPEFACE.serif,
  },
  {
    key: 'mono',
    name: 'Mono',
    desc: '+12% automation speed',
    color: TYPEFACE.mono,
  },
  {
    key: 'bold',
    name: 'Bold',
    desc: '+10% word burst power',
    color: TYPEFACE.bold,
  },
  {
    key: 'italic',
    name: 'Italic',
    desc: '−8% operator cooldown',
    color: TYPEFACE.italic,
  },
] as const

const MAX_TIERS = 10

export function TypefaceTree() {
  const type = useGame((s) => s.type)
  const typeface = useGame((s) => s.typeface)
  const investTypeface = useGame((s) => s.investTypeface)
  const edition = useGame((s) => s.edition)

  if (edition === 0) return null

  return (
    <div className="rounded-lg border border-ink-border bg-ink-panel p-4">
      <div className="mb-3 flex items-center justify-between">
        <h2 className="text-xs font-bold uppercase tracking-widest text-ink-teal">
          Typeface Tree
        </h2>
        <span className="text-[10px] text-ink-muted">
          {type} Type available
        </span>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {BRANCHES.map((b) => {
          const tier = typeface[b.key] ?? 0
          const cost = Math.floor(
            GLOBAL.typefaceBaseCost * Math.pow(GLOBAL.typefaceCostGrowth, tier),
          )
          const canInvest = tier < MAX_TIERS && type >= cost
          return (
            <div key={b.key} className="rounded border border-ink-border bg-ink-bg p-2">
              <div className="mb-1 text-xs font-bold" style={{ color: b.color }}>
                {b.name}
              </div>
              <div className="mb-2 text-[10px] text-ink-muted">{b.desc}</div>
              <div className="mb-2 flex gap-0.5">
                {Array.from({ length: MAX_TIERS }).map((_, i) => (
                  <div
                    key={i}
                    className="h-1.5 flex-1 rounded-full"
                    style={{
                      backgroundColor: i < tier ? b.color : UI.tierEmpty,
                    }}
                  />
                ))}
              </div>
              <button
                disabled={!canInvest}
                onClick={() => investTypeface(b.key)}
                className={`w-full rounded border px-2 py-1 text-[10px] font-bold transition ${
                  canInvest
                    ? 'border-ink-tealdim text-ink-teal hover:shadow-glow'
                    : 'border-ink-border text-ink-muted opacity-50'
                }`}
              >
                {tier >= MAX_TIERS ? 'Max' : `${cost} Type`}
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}
